import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import type { TooltipFormatter } from 'vue-slider-component/typings/typings';


export default /*#__PURE__*/_defineComponent({
  __name: 'CSlider',
  props: {
    value: null,
    min: { default: 0 },
    max: { default: 100 },
    disabled: { type: Boolean },
    formatter: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', val: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: number, min: number, max: number, disabled?: boolean, formatter?: TooltipFormatter };





const _value = ref(0);

const model = computed({
    get: () => props.value ?? _value.value,
    set: (val: number) => {
        _value.value = val;
        emit('input', val);
    }
});

return { __sfc: true,props, emit, _value, model, VueSlider }
}

})